let csrfToken = '';
const inFlightGets=new Map<string,Promise<unknown>>();

export class ApiError extends Error {
  readonly status: number;
  readonly code: string | null;
  readonly body: Record<string, unknown>;

  constructor(status: number, body: Record<string, unknown>) {
    super(typeof body.message === 'string' && body.message ? body.message : 'Не удалось выполнить действие');
    this.name = 'ApiError';
    this.status = status;
    this.code = typeof body.code === 'string' ? body.code : null;
    this.body = body;
  }
}

export function setCsrfToken(value: string) {
  csrfToken = value;
}

export function clearCsrfToken() {
  csrfToken = '';
  inFlightGets.clear();
}

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method=(init.method??'GET').toUpperCase();
  if(method==='GET'){const existing=inFlightGets.get(path);if(existing)return existing as Promise<T>}
  const headers = new Headers(init.headers);
  if (init.body && !(init.body instanceof FormData)) {
    headers.set('content-type', 'application/json');
  }
  if (init.method && init.method !== 'GET' && csrfToken) {
    headers.set('x-csrf-token', csrfToken);
  }

  const isStudioStartCheck = /\/api\/studio\/projects\/[^/]+\/executions\/(preflight|start)$/.test(path);
  const controller = isStudioStartCheck ? new AbortController() : null;
  let timedOut = false;
  const timeout = controller
    ? setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, 15_000)
    : null;
  const request=(async()=>{try {
    const response = await fetch(path, { ...init, headers, credentials: 'include', ...(controller ? { signal: controller.signal } : {}) });
    const body = await response.json().catch(() => ({ message: 'Ошибка соединения' })) as Record<string, unknown>;
    if (!response.ok) throw new ApiError(response.status, body);
    return body as T;
  } catch (error) {
    if (timedOut) throw new Error('Сервер временно недоступен. Проверьте соединение и попробуйте ещё раз. Новая задача не была отправлена.');
    throw error;
  } finally {
    if (timeout !== null) clearTimeout(timeout);
  }})();
  if(method==='GET'){inFlightGets.set(path,request);request.finally(()=>{if(inFlightGets.get(path)===request)inFlightGets.delete(path)}).catch(()=>undefined)}else inFlightGets.clear();
  return request;
}
